import React, { useState } from "react";
import { T } from "./theme";
import { SectionHeader } from "./ui";
import TimesAdmin from "./TimesAdmin";
import MetasIndividuais from "./MetasIndividuais";
import Premios from "./Premios";
import Aceleradores from "./Aceleradores";
import Usuarios from "./Usuarios";
import Regulamento from "./Regulamento";
import ComissoesAdmin from "./ComissoesAdmin";
import RegulamentoEdit from "./RegulamentoEdit";

const TABS_ALL = [
  { id: "timesAdmin", label: "⚡ Gestão de Times", icon: "⚡", proprietarioOnly: false },
  { id: "comissoes", label: "💸 Comissões", icon: "💸", proprietarioOnly: true },
  { id: "metas", label: "🎯 Metas Individuais", icon: "🎯", proprietarioOnly: false },
  { id: "premios", label: "🎁 Prêmios", icon: "🎁", proprietarioOnly: false },
  { id: "aceleradores", label: "🚀 Aceleradores", icon: "🚀", proprietarioOnly: false },
  { id: "usuarios", label: "👥 Usuários", icon: "👥", proprietarioOnly: false },
  { id: "regulamento", label: "📖 Regulamento", icon: "📖", proprietarioOnly: false },
  { id: "regulamentoEdit", label: "✏️ Editar Regulamento", icon: "✏️", proprietarioOnly: false },
];

export default function Configuracoes(props) {
  const isProprietario = props.currentUser?.role === "proprietario";
  const TABS = TABS_ALL.filter(t => !t.proprietarioOnly || isProprietario);
  const [tab, setTab] = useState("timesAdmin");

  function renderTab() {
    switch (tab) {
      case "timesAdmin": return <TimesAdmin times={props.times} setTimes={props.setTimes} corretores={props.corretores} setCorretores={props.setCorretores} />;
      case "comissoes": return isProprietario ? <ComissoesAdmin /> : null;
      case "metas": return <MetasIndividuais metasIndividuais={props.metasIndividuais} setMetasIndividuais={props.setMetasIndividuais} corretores={props.corretores} />;
      case "premios": return <Premios premios={props.premios} setPremios={props.setPremios} />;
      case "aceleradores": return <Aceleradores metas={props.metas} setMetas={props.setMetas} aceleradores={props.aceleradores} setAceleradores={props.setAceleradores} />;
      case "usuarios": return <Usuarios users={props.users} setUsers={props.setUsers} corretores={props.corretores} currentUser={props.currentUser} />;
      case "regulamento": return <Regulamento currentUser={props.currentUser} />;
      case "regulamentoEdit": return <RegulamentoEdit />;
      default: return null;
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <SectionHeader icon="⚙️" title="Configurações" subtitle="Gestão da plataforma" />
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: "8px 14px", borderRadius: T.r.md,
            background: tab === t.id ? T.brand + "22" : T.card,
            border: `1px solid ${tab === t.id ? T.brand : T.border}`,
            color: tab === t.id ? T.brand : T.textSec,
            cursor: "pointer", fontSize: 11, fontWeight: 600,
            fontFamily: "inherit",
          }}>
            {t.label}
          </button>
        ))}
      </div>
      {renderTab()}
    </div>
  );
}
